import { Divider, Grid2 } from '@mui/material'
import AsterTab from 'asterX-UI/Tabs/AsterTab'
import AsterTabs from 'asterX-UI/Tabs/AsterTabs'
import React, { useEffect, useState } from 'react'

export const CustomTabs = ({ getTabs, page,readonly }) => {
  const [activeTab, setActiveTab] = useState(0)

  const tabs = getTabs || []
  const TabBody = tabs[activeTab]?.component || null

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue)
  }

  useEffect(() => {
    if(readonly) setActiveTab(0)
  })

  return (
    <Grid2 sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Grid2 size={{ xs: 12 }}>
        <AsterTabs value={activeTab} onChange={handleChangeTab} aria-label="tabs">
          {tabs?.map(({ label }, index) => (
            <AsterTab key={`tabs-${index}`} label={label} {...a11yProps(index)} />
          ))}
        </AsterTabs>
        <Divider />
      </Grid2>

      <Grid2 size={{ xs: 12 }} sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {TabBody && <TabBody page={page} label={tabs[activeTab]?.label} readonly={readonly} />}
      </Grid2>
    </Grid2>
  )
}

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`
  }
}
